import { gql } from '@apollo/client';

export const LOGIN = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) @client
  }
`;

export const TOKENIZED_LOGIN = gql`
  mutation TokenizedLogin($token: String!) {
    tokenizedLogin(token: $token) @client
  }
`;

export const REGISTER_INVITED_PARTNER = gql`
  mutation RegisterInvitedPartner($input: PartnerRegistrationInput!) {
    registerInvitedPartner(input: $input)
  }
`;

export const SEND_PASSWORD_RESET_MAIL = gql`
  mutation SendPasswordResetMail($email: String!) {
    sendPasswordResetMail(email: $email) @client
  }
`;

export const RESEND_USER_VERIFICATION_MAIL = gql`
  mutation ResendVerificationEmail($email: String!) {
    resendVerificationEmail(email: $email)
  }
`;

export const SEND_PW_RESET_MAIL = gql`
  mutation SendPwResetMail($email: String!) {
    sendPwResetMail(email: $email) {
      timestamp
    }
  }
`;

/** This is triggered from the user if the token is invalid */
export const RESEND_INVITE_MAIL = gql`
  mutation ResendInviteEmail($email: String!) {
    resendInviteEmail(email: $email)
  }
`;

/**
 * This mutation is still in the secure folder, since the backend sends the token to the FE via query params
 * TODO: Move this mutation to auth routes and remove the token from the query params. Instead use params like companyId like the registerInvitedPartner mutation does.
 * This mutation adds the token manually to the http request header and call the real mutation REGISTER_INVITED_USER
 */
export const REGISTER_INVITED_USER_WITH_TOKEN = gql`
  mutation RegisterInvitedUserWithToken($input: InvitedUserRegistrationInput!, $token: String!) {
    registerInvitedUserWithToken(input: $input, token: $token) @client
  }
`;
